<template lang="pug">
small.company-stock
  strong {{ props.stockSymbol[0] }}
  span {{ props.stockSymbol[1] }}
  span {{ props.stock.last ? props.stock.last : '' }}
  span.company-stock__up(v-if="parseFloat(props.stock.change) > 0") ▲
  span.company-stock__down(v-if="parseFloat(props.stock.change) < 0") ▼
  span {{ props.stock.change }}
  span {{ `(${Math.round(props.stock.percent_change * 100) / 100}%)` }}
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type { Stock } from '@/entities/stock'
import type { Company } from '@/entities/company'

const props = defineProps({
  stock: {
    type: Object as PropType<Stock>,
    required: true,
  },
  stockSymbol: {
    type: Array as PropType<Company[]>,
    required: true,
  },
})
</script>

<style lang="stylus" scoped>
.company-stock
  @apply text-sm text-gray-850 block uppercase pt-1

  span
    @apply pl-2

  &__up
    color #78CC60

  &__down
    color #DE6B6B
</style>
